"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

/**
 * @module UserScriptCriticalError
 * @requires UserScriptCriticalError
 * @exports UserScriptCriticalError
 */

/**
 * Uses in user defined scripts. Prevents the edit form before opening and displays the transmitted error text.
 * @example
 * model.formEvents.onInitialized = data => {
 *      let parentFld = model.getFieldByName(SParent).value();
 *
 *      if (!parentFld) throw new window.UserScriptCriticalError('Не выбрано предложений!');
 *  };
 *
 */
var UserScriptCriticalError =
/*#__PURE__*/
function (_Error) {
  _inherits(UserScriptCriticalError, _Error);

  /**
   * @param {string} errorMessage
   */
  function UserScriptCriticalError(errorMessage) {
    var _this;

    _classCallCheck(this, UserScriptCriticalError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserScriptCriticalError).call(this, errorMessage));
    _this.name = _this.constructor.name;
    _this.message = errorMessage;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
    } else {
      _this.stack = new Error(errorMessage).stack;
    }

    return _this;
  }

  return UserScriptCriticalError;
}(_wrapNativeSuper(Error));

export { UserScriptCriticalError as default };